




























































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { SfHeading, SfProperty } from '@storefront-ui/vue';
import { Discount } from '@vue-storefront/magento-api';
import GiftCard from '~/components/GiftCard.vue';
import getShippingMethodPrice from '~/helpers/checkout/getShippingMethodPrice';
import useCart from '~/modules/checkout/composables/useCart';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import CouponCode from '../../../components/CouponCode.vue';
import { useCartStore } from '../stores/cart';

export default defineComponent({
  name: 'CartPreview',
  components: {
    SfHeading,
    SfProperty,
    CouponCode,
    GiftCard,
  },
  setup() {
    const { cart, removeItem, updateItemQty } = useCart();
    const cartStore = useCartStore();

    const listIsHidden = ref(false);
    const products = computed(() => cartGetters.getItems(cart.value));
    const totals = computed(() => cartGetters.getTotals(cart.value));
    const appliedCoupons = computed(() => cartGetters.getCoupons(cart.value));
    const appliedGiftCards = computed(() => cartGetters.getAppliedGiftCards(cart?.value));
    const totalDiscounts = computed(() => cartGetters.getTotalDiscount(cart?.value));
    const couponDiscountPrice = computed(() => totalDiscounts.value?.find((discount: Discount) => discount.label.includes('Rabatt'))?.amount?.value);
    const items = computed(() => cartGetters.getItems(cart.value));

    const selectedShippingMethod = computed(() => cartGetters.getSelectedShippingMethod(cart.value));
    const { hasOnlyGiftCards } = useCart();
    const canShowShippingMethod = computed(() => cartStore.canShowShippingMethod);

    return {
      cart,
      appliedCoupons,
      items,
      listIsHidden,
      products,
      totals,
      removeItem,
      updateItemQty,
      cartGetters,
      getShippingMethodPrice,
      selectedShippingMethod,
      hasOnlyGiftCards,
      appliedGiftCards,
      couponDiscountPrice,
      canShowShippingMethod,
    };
  },
});
